var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-toggles col-100"},[_c('router-link',{staticClass:"overview-btn",attrs:{"to":{
      name: 'disease-progression',
      params: { name: 'mobility', year: _vm.$store.state.year },
    }},nativeOn:{"click":function($event){return _vm.updateAnalytics('overview')}}},[_vm._v(" Overview")]),_c('router-link',{staticClass:"overview-btn",class:_vm.$store.state.currentDetailedTab !== '' ? 'router-link-active' : '',attrs:{"to":{
      name: 'visualization',
      params: {
        name: 'mobility',
        year: _vm.$store.state.year,
        startTab: 'mobility',
      },
    }},nativeOn:{"click":function($event){return _vm.updateAnalytics('detailed')}}},[_vm._v(" Detailed")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }